var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "trial-used-overlay",
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "trial-used-modal",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "trial-modal-title"
          }
        },
        [
          _c("div", { staticClass: "trial-modal-header" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "trial-modal-close",
                attrs: { "aria-label": "閉じる" },
                on: {
                  click: function($event) {
                    _vm.$emit("close")
                  }
                }
              },
              [_vm._v("×")]
            )
          ]),
          _vm._v(" "),
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.PremiumTrialFlg2Exp) }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "trial-modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "trial-btn-register",
                on: {
                  click: function($event) {
                    _vm.$emit("confirm")
                  }
                }
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "18",
                      height: "18",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }
                  },
                  [_c("path", { attrs: { d: "M5 12h14M12 5l7 7-7 7" } })]
                ),
                _vm._v("\n        プレミアムに登録する\n      ")
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "trial-btn-close-text",
                on: {
                  click: function($event) {
                    _vm.$emit("close")
                  }
                }
              },
              [_vm._v("閉じる")]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { attrs: { id: "trial-modal-title" } }, [
      _vm._v("無料トライアルは"),
      _c("br"),
      _vm._v("すでにご利用済みです")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25425c1a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25425c1a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/setting/TrialUsedModal.vue
// module id = null
// module chunks = 